<div class="flex min-h-dvh flex-col bg-background">
  <app-skip-link />
  <app-site-header [variant]="headerVariant()" />

  <main id="main-content" tabindex="-1" class="flex-1 focus:outline-none">
    <router-outlet />
  </main>

  <app-site-footer />
</div>
